import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import KnotsInscriber from "./knotsInscriber";
import { ReservedProvider } from "./ReservedContext";
import "./App.css";

export default function App() {
  return (
    <BrowserRouter>
      <ReservedProvider>
        <Routes>
          {/* Redirect root to inscribeknots */}
          <Route path="/" element={<Navigate to="/inscribeknots" replace />} />

          {/* Inscriber flow */}
          <Route path="/inscribeknots/*" element={<KnotsInscriber />} />

          {/* Optional: keep old path working */}
          <Route path="/inscribe/*" element={<Navigate to="/inscribeknots" replace />} />

          {/* Catch-all → inscribeknots */}
          <Route path="*" element={<Navigate to="/inscribeknots" replace />} />
        </Routes>
      </ReservedProvider>
    </BrowserRouter>
  );
}
